import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2026-01-31 22:57:43 +0100 (Sat, 31 Jan 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160223 $
//  Purpose   : viewer parts
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Menu } from 'semantic-ui-react';
import { ReflexContainer, ReflexSplitter, ReflexElement } from 'react-reflex';
// ---Framework imports
import { funcPart } from 'uix/parts';
import { GlobalMenu, DebugFeature } from 'uix/components';
import { decodeSlimLink } from 'uix/utils';
import { TitleList } from 'uix/frontend/components';
import { usePersistentShallow } from 'uix/hooks';
// ---Local imports
import { Viewer, goTreeViewer } from './components';
// ---Globals
export const ViewerTitleList = ({ go })=>/*#__PURE__*/ _jsx(TitleList, {
        onSelectTitle: (title)=>goTreeViewer(go, title)
    });
let decodeOtid = (id)=>decodeSlimLink(id).otid || id;
export const ViewerGrid = funcPart({
    className: 'attached'
}, ({ imageLocs, request })=>{
    let [ui, setUI] = usePersistentShallow('viewerOptions', {
        multi: false,
        multiRows: false,
        multiCols: false,
        __version__: 2
    });
    let columns = ui.multiCols ? 2 : 1;
    let rows = ui.multiRows ? 2 : 1;
    let renderMulti = (columns, rows)=>{
        let Pane = ({ col, row })=>/*#__PURE__*/ _jsx("div", {
                className: "reflexPane",
                children: /*#__PURE__*/ _jsx(Viewer, {
                    vid: `${col}${row}`,
                    imageLocs: imageLocs,
                    otid: decodeOtid(request.id)
                })
            });
        let Columns = ({ row })=>{
            if (columns == 1) {
                return /*#__PURE__*/ _jsx(Pane, {
                    col: "0",
                    row: row
                });
            }
            return /*#__PURE__*/ _jsxs(ReflexContainer, {
                orientation: "vertical",
                className: `reflexColumns count${columns} row${row}`,
                children: [
                    /*#__PURE__*/ _jsx(ReflexElement, {
                        children: /*#__PURE__*/ _jsx(Pane, {
                            col: "0",
                            row: row
                        })
                    }),
                    /*#__PURE__*/ _jsx(ReflexSplitter, {}),
                    /*#__PURE__*/ _jsx(ReflexElement, {
                        children: /*#__PURE__*/ _jsx(Pane, {
                            col: "1",
                            row: row
                        })
                    })
                ]
            });
        };
        if (rows == 1) {
            return /*#__PURE__*/ _jsx(Columns, {
                row: "0"
            });
        }
        return /*#__PURE__*/ _jsxs(ReflexContainer, {
            orientation: "horizontal",
            className: `reflexRows count${rows}`,
            children: [
                /*#__PURE__*/ _jsx(ReflexElement, {
                    children: /*#__PURE__*/ _jsx(Columns, {
                        row: "0"
                    })
                }),
                /*#__PURE__*/ _jsx(ReflexSplitter, {}),
                /*#__PURE__*/ _jsx(ReflexElement, {
                    children: /*#__PURE__*/ _jsx(Columns, {
                        row: "1"
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DebugFeature, {
                children: /*#__PURE__*/ _jsxs(GlobalMenu, {
                    children: [
                        /*#__PURE__*/ _jsx(Menu.Item, {
                            content: "Mordor",
                            style: {
                                fontWeight: 'bold'
                            }
                        }),
                        /*#__PURE__*/ _jsx(Menu.Item, {
                            active: ui.multiRows,
                            onClick: ()=>setUI({
                                    multiRows: !ui.multiRows
                                }),
                            icon: "list layout"
                        }),
                        /*#__PURE__*/ _jsx(Menu.Item, {
                            active: ui.multiCols,
                            onClick: ()=>setUI({
                                    multiCols: !ui.multiCols
                                }),
                            icon: "columns"
                        })
                    ]
                })
            }),
            columns > 1 || rows > 1 ? renderMulti(columns, rows) : /*#__PURE__*/ _jsx(Viewer, {
                vid: "0",
                imageLocs: imageLocs,
                otid: decodeOtid(request.id)
            })
        ]
    });
});
export { I3FDetails } from './i3f';
